import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-messagebox-dialog',
    imports: [TranslateModule, MatDialogModule, MatButtonModule],
    templateUrl: './messagebox-dialog.component.html',
    styleUrls: ['./messagebox-dialog.component.scss']
})
export class MessageBoxDialogComponent {
  public mode: string;

  public title = '';
  public buttonNoText = '';
  public buttonYesText = '';
  public buttonOkText = '';

  public html: SafeHtml | null = null;

  constructor(
    public dialogRef: MatDialogRef<MessageBoxDialogComponent>,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService
  ) {
    this.mode = 'OK';
    this.buttonNoText = this.translateService.instant('BUTTON_NO');
    this.buttonYesText = this.translateService.instant('BUTTON_YES');
    this.buttonOkText = this.translateService.instant('BUTTON_OK');
  }

  public setHtml(html: string, placeHolders?: Array<any>) {
    if (placeHolders) {
      for (let i = 0; i < placeHolders.length; i++) {
        const placeHolder = placeHolders[i];
        const regExp = new RegExp('%' + placeHolder.ph + '%', 'g');
        html = html.replace(regExp, placeHolder.txt);
      }
    }
    const htmlSafe = this.sanitizer.bypassSecurityTrustHtml(html);
    this.html = htmlSafe;
  }

  public setText(mode: string, text: string, placeHolders: Array<any>) {
    this.mode = mode;
    let html = '<span>' + text + '</span>';
    if (placeHolders) {
      for (let i = 0; i < placeHolders.length; i++) {
        const placeHolder = placeHolders[i];
        const regExp = new RegExp('%' + placeHolder.ph + '%', 'g');
        html = html.replace(regExp, placeHolder.txt);
      }
    }
    const htmlSafe = this.sanitizer.bypassSecurityTrustHtml(html);
    this.html = htmlSafe;
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
